<div class="container">
    <div>LA MAISON DE L'ASSURANCE DU CENTRE EST</div>
    <div class="liens">
        <div>@2020</div>-
        <div  (click)="nav.nav('mentions-legales')">Mentions légales</div>
        <div>-</div>
        <div  (click)="nav.nav('vie-privee')">Vie privée</div>
        <div>-</div>
        <div  (click)="nav.nav('privacy')">Infos cookies</div>
    </div>
</div>